import React from "react";
import styled from "styled-components";
import twitter from "../../../assets/twitter.jpg";
import TwitterTechIcons from "./TwitterTechIcons";
import TwitterDescription from "./TwitterDescription";
import ProjectBtns from "../ProjectBtns";

export default function Twitter() {
  return (
    <ProjectContainer>
      <ProjectDesc>
        <h2>My clone of Twitter</h2>
        <p>
          Fullstack project - React/NextJs/Firebase - This project is designed
          to understand the fundamental concepts of web development, database
          management, and front-end/backend integration.{" "}
        </p>
        <div>
          <Features>Used technologies:</Features>
          <TwitterTechIcons />
        </div>
        <div>
          <Features>Features/Description</Features>
          <TwitterDescription />
        </div>
      </ProjectDesc>
      <ProjectBtns>
        <button>
          <a
            href="https://educational-copy-of-twitter.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Try it live
          </a>
        </button>
        <button>
          <a
            href="https://github.com/Kamildeeal/educational_copy_of_twitter"
            target="_blank"
            rel="noopener noreferrer"
          >
            View source
          </a>
        </button>
      </ProjectBtns>
      <Overview>
        <h2>Hover to see overview</h2>
        <div>
          <ProjectImageWrapper>
            <ProjectImage src={twitter} alt="twitter_teaser" />
          </ProjectImageWrapper>
        </div>
      </Overview>
    </ProjectContainer>
  );
}

const ProjectDesc = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  & > p {
    margin-bottom: 20px;
  }

  & > h2 {
    color: rgba(145, 213, 246, 0.8);
  }
  & > h2,
  div {
    margin-bottom: 20px;

    @media (max-width: 460px) {
      margin-bottom: 10px;
    }
  }
`;

const ProjectContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  margin-top: 30px;
  margin-bottom: 80px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  overflow: hidden;
  color: white;
  padding: 10px 20px;
  transition: all 0.1s ease;

  &:hover {
    background: rgba(36, 36, 41, 0.87);
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
  @media (max-width: 460px) {
    margin-bottom: 16px;
  }
`;

const ProjectImageWrapper = styled.div`
  height: 400px;
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  border: 2px solid gray;

  &:hover img {
    transform: translateY(-68%);
  }
`;
const Overview = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;

  > h2 {
    margin-bottom: 10px;
  }

  @media (max-width: 1024px) {
    align-items: center;
    justify-content: center;
    > h2 {
      justify-content: center;
    }
  }
  @media (max-width: 670px) {
    display: none;
  }
`;

const ProjectImage = styled.img`
  height: auto;
  width: auto;
  max-height: 500%;
  transition: transform 4s ease-in-out;
   @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: cente;r
  }
`;

const Features = styled.div`
  color: rgba(145, 213, 246, 0.8);
  font-weight: bold;
  margin-bottom: 0 !important;
`;
